const dev = {
  apiURL: 'http://localhost:3001',
  recurrentApiURL: 'http://localhost:3015',
  domain: 'http://localhost:3000',
  razorpaySubsciptionApiURL: 'http://localhost:3016',
  dashboardServiceUrl: 'http://localhost:3009',
  learningServiceUrl: 'http://localhost:3010/',
  notificationServiceUrl: 'http://localhost:3012',
  leadSquareUrl: 'http://localhost:3017',
  rewardsAPI: '',
  orderDomain: 'http://localhost:3005',
  affiliateDomain: 'http://localhost:3007',
  checkoutAPI: 'http://localhost:3005',
  logsDomain: 'http://localhost:3006',
  cloudFront: 'https://assets.log2base2.com',
  tazapayApi: 'http://localhost:3020',
  otpVerificationStatus: true,
  primeOfferStatus: true,
  profileURL: 'http://localhost:3011',
  otpServiceUrl: 'http://localhost:3021',
  stripe: {
    publishKey: 'pk_test_51KT65dSIfeTpTwoDkPi40ehJqUIO0uFuEiBqn4hqVhQlabzKG8E0dwoIlahVFk4kHxTtyZHldgW33YwSbLJFKAKa00CA8ST6Ql',
  },
  razorpay: {
    publishKey: 'rzp_test_FVyLwTRm2XjrHD',
  },
  cognito: {
    DOMAIN: 'log2base2dev.auth.ap-southeast-1.amazoncognito.com',
    REDIRECT_URI: 'http://localhost:3000/login',
    SIGNOUT_URI: 'http://localhost:3000/',
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_obpi57Xae',
    APP_CLIENT_ID: '37nifbp0ftjnbaqjaivccbrddd',
    IDENTITY_POOL_ID: 'ap-southeast-1:dc98bed6-89a0-4d46-8ea2-8e8152aee1ae',
    IDP: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_obpi57Xae',
  },
  paymentRedirect: 'http://localhost:3000/signup?status=true',
  PAYPAL_CLIENT_ID: 'ATqFA_87kztPYRhF3GqcYWN9bFphFQKu31Iy81GN1BRcAo6rhRrL0eCsmZCtisS2Jr6ASldzfKZcrOP9',
};

const test = {
  apiURL: 'https://tcs5iq21w2.execute-api.ap-southeast-1.amazonaws.com/test',
  dashboardServiceUrl: 'https://ji4iw4nil6.execute-api.ap-southeast-1.amazonaws.com/test',
  razorpaySubsciptionApiURL: 'http://localhost:3016',
  recurrentApiURL: 'https://4r1sva8md4.execute-api.ap-southeast-1.amazonaws.com/test',
  learningServiceUrl: 'https://i0l7qmeloj.execute-api.ap-southeast-1.amazonaws.com/test/',
  notificationServiceUrl: 'https://1zw3ptdvic.execute-api.ap-southeast-1.amazonaws.com/test',
  rewardsAPI: 'https://7t6w1pm7d2.execute-api.ap-southeast-1.amazonaws.com/test',
  affiliateDomain: 'https://inkpdsq338.execute-api.ap-southeast-1.amazonaws.com/test',
  orderDomain: 'https://orders-test.log2base2.com',
  checkoutAPI: 'https://checkout-test.log2base2.com',
  logsDomain: 'https://qrmbodsei9.execute-api.ap-southeast-1.amazonaws.com/test',
  cloudFront: 'https://assets.log2base2.com',
  leadSquareUrl: 'https://uce71dlq2l.execute-api.ap-southeast-1.amazonaws.com/test',
  profileURL: 'https://tximy8jtq6.execute-api.ap-southeast-1.amazonaws.com/test',
  tazapayApi: ' https://riyoxwqfgd.execute-api.ap-southeast-1.amazonaws.com/test',
  domain: 'https://dev.log2base2.com',
  otpServiceUrl: 'https://teotp.log2base2.com',
  otpVerificationStatus: true,
  primeOfferStatus: true,
  stripe: {
    publishKey: 'pk_test_51KT65dSIfeTpTwoDkPi40ehJqUIO0uFuEiBqn4hqVhQlabzKG8E0dwoIlahVFk4kHxTtyZHldgW33YwSbLJFKAKa00CA8ST6Ql',
  },
  razorpay: {
    publishKey: 'rzp_test_FVyLwTRm2XjrHD',
  },
  cognito: {
    DOMAIN: 'log2base2dev.auth.ap-southeast-1.amazoncognito.com',
    REDIRECT_URI: 'https://dev.log2base2.com/login',
    SIGNOUT_URI: 'https://dev.log2base2.com/',
    REGION: 'ap-southeast-1',
    USER_POOL_ID: 'ap-southeast-1_obpi57Xae',
    APP_CLIENT_ID: '37nifbp0ftjnbaqjaivccbrddd',
    IDENTITY_POOL_ID: 'ap-southeast-1:dc98bed6-89a0-4d46-8ea2-8e8152aee1ae',
    IDP: 'cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_obpi57Xae',
  },
  paymentRedirect: 'https://dev.log2base2.com/signup?status=true',
  PAYPAL_CLIENT_ID: 'ATqFA_87kztPYRhF3GqcYWN9bFphFQKu31Iy81GN1BRcAo6rhRrL0eCsmZCtisS2Jr6ASldzfKZcrOP9',
};

const stage = {
  apiURL: 'https://wugf1qwev5.execute-api.ap-south-1.amazonaws.com/stage',
  rewardsAPI: 'https://6gauf5ubbj.execute-api.ap-south-1.amazonaws.com/stage',
  dashboardServiceUrl: 'https://i27ivhz0ui.execute-api.ap-south-1.amazonaws.com/stage',
  learningServiceUrl: 'https://yydega3koi.execute-api.ap-south-1.amazonaws.com/stage/',
  orderDomain: 'https://orders-stage.log2base2.com',
  affiliateDomain: 'https://0mxlc3u2t4.execute-api.ap-south-1.amazonaws.com/stage',
  tazapayApi: ' https://riyoxwqfgd.execute-api.ap-southeast-1.amazonaws.com/test',
  checkoutAPI: 'https://checkout-stage.log2base2.com',
  logsDomain: 'https://logs-stage.log2base2.com',
  cloudFront: 'https://assets.log2base2.com',
  domain: 'https://stage.log2base2.com',
  otpVerificationStatus: true,
  primeOfferStatus: true,
  otpServiceUrl: 'https://teotp.log2base2.com',
  cognito: {
    DOMAIN: 'log2base2test.auth.ap-south-1.amazoncognito.com',
    REDIRECT_URI: 'https://stage.log2base2.com/login',
    SIGNOUT_URI: 'https://stage.log2base2.com/',
    REGION: 'ap-south-1',
    USER_POOL_ID: 'ap-south-1_ngmIiuFwq',
    APP_CLIENT_ID: 'ijja64j73q0m9a533e3k5hoih',
    IDENTITY_POOL_ID: 'ap-south-1:b3e08e2b-a922-4182-b0f4-eaaaf9433b0c',
    IDP: 'cognito-idp.ap-south-1.amazonaws.com/ap-south-1_ngmIiuFwq',
  },
  paymentRedirect: 'https://stage.log2base2.com/signup?status=true',
  recurrentApiURL: 'https://42kvir3bb2.execute-api.ap-south-1.amazonaws.com/prod',
  stripe: {
    publishKey: 'pk_test_51KT65dSIfeTpTwoDkPi40ehJqUIO0uFuEiBqn4hqVhQlabzKG8E0dwoIlahVFk4kHxTtyZHldgW33YwSbLJFKAKa00CA8ST6Ql',
  },
  razorpay: {
    publishKey: 'rzp_live_yor3OYgoJWDLKQ',
  },
  PAYPAL_CLIENT_ID: 'ATqFA_87kztPYRhF3GqcYWN9bFphFQKu31Iy81GN1BRcAo6rhRrL0eCsmZCtisS2Jr6ASldzfKZcrOP9',
};

const prod = {
  apiURL: 'https://1lem63u42c.execute-api.ap-south-1.amazonaws.com/prod',
  recurrentApiURL: 'https://42kvir3bb2.execute-api.ap-south-1.amazonaws.com/prod',
  dashboardServiceUrl: 'https://i1veqjfjx0.execute-api.ap-south-1.amazonaws.com/prod',
  learningServiceUrl: 'https://4jmk3n7492.execute-api.ap-south-1.amazonaws.com/prod/',
  rewardsAPI: 'https://qg91mxew4d.execute-api.ap-south-1.amazonaws.com/prod',
  affiliateDomain: 'https://3xgr6lqdgj.execute-api.ap-south-1.amazonaws.com/prod',
  notificationServiceUrl: 'https://kcz5hexe6f.execute-api.ap-south-1.amazonaws.com/prod',
  orderDomain: 'https://orders.log2base2.com',
  checkoutAPI: 'https://checkout.log2base2.com',
  logsDomain: 'https://wtgn1xzrb9.execute-api.ap-south-1.amazonaws.com/prod',
  profileURL: 'https://2iije9i2ug.execute-api.ap-south-1.amazonaws.com/prod',
  tazapayApi: 'https://lnef2vtre7.execute-api.ap-south-1.amazonaws.com/prod',
  cloudFront: 'https://assets.log2base2.com',
  domain: 'https://log2base2.com',
  otpServiceUrl: 'https://otp.log2base2.com',
  otpVerificationStatus: true,
  primeOfferStatus: true,
  cognito: {
    DOMAIN: 'auth.log2base2.com',
    REDIRECT_URI: 'https://log2base2.com/login',
    SIGNOUT_URI: 'https://log2base2.com/',
    REGION: 'ap-south-1',
    USER_POOL_ID: 'ap-south-1_g2VdxHlzD',
    APP_CLIENT_ID: '2ai373ujcr4ibd2uus8sgjdjou',
    IDENTITY_POOL_ID: 'ap-south-1:9f759bbd-84af-4bc2-8c9f-5281b7c4092b',
    IDP: 'cognito-idp.ap-south-1.amazonaws.com/ap-south-1_g2VdxHlzD',
  },
  paymentRedirect: 'https://log2base2.com/signup?status=true',
  stripe: {
    publishKey: 'pk_live_51KT65dSIfeTpTwoDIyOrOBLY6w2mElaHW8nWK9PcmigMZkJ3i0L3nLgPSKw0QfNe7CoK72D8ev8umVjquQQJSOxA00OOqIDUvn',
  },
  razorpay: {
    publishKey: 'rzp_live_yor3OYgoJWDLKQ',
  },
  PAYPAL_CLIENT_ID: 'ARRgeGGDKO2IWw6psHPaPrvpwAN20_q6PSktQKrv8v-GE3emAVeDuSkN0cg7k9wzb7Eup9btBVCLBzEK',
};

const config = process.env.REACT_APP_STAGE === 'prod' ? prod : process.env.REACT_APP_STAGE === 'stage' ? stage : process.env.REACT_APP_STAGE === 'test' ? test : dev;

export default {
  ...config,
};
